/**
 * Todo lo relacionado con rutas Trafigura en el router Vue:
 * Pantallas Trafigura con componente propio (no admin + ?plataforma=trafigura).
 * Se registran antes del menú API en store/setRoutes para que tengan prioridad sobre admin/rutas.
 */

/** Mapa path → path corregido (beforeEach en router/index.js). */
export const trafiguraPathRedirects = {
  "/Trafigura": "/Trafigura/Dashboard",
  "/Trafigura/Usuarios": "/Trafigura/Seguridad/Usuarios",
  "/Trafigura/Permisos": "/Trafigura/Seguridad/Permisos",
  "/Trafigura/Roles": "/Trafigura/Seguridad/Roles",
  "/Trafigura/Trafigura/Seguridad/Usuarios": "/Trafigura/Seguridad/Usuarios",
  "/Trafigura/Trafigura/Seguridad/Permisos": "/Trafigura/Seguridad/Permisos",
  "/Trafigura/Trafigura/Seguridad/Roles": "/Trafigura/Seguridad/Roles",
  "/Trafigura/Trafigura/Flota/Vehiculos": "/Trafigura/Flota/Vehiculos",
  "/Trafigura/Trafigura/Flota/Remolques": "/Trafigura/Flota/Remolques",
  "/Trafigura/Trafigura/Flota/Conductores": "/Trafigura/Flota/Conductores",
  "/Trafigura/Trafigura/Flota/Documentos": "/Trafigura/Flota/Documentos",
  "/Trafigura/Trafigura/Flota/PaquetesDocs": "/Trafigura/Flota/PaquetesDocs",
  "/Trafigura/Trafigura/Flota/TiposVehiculos": "/Trafigura/Flota/TiposVehiculos",
  "/Trafigura/Trafigura/Admin/Geocercas": "/Trafigura/Admin/Geocercas",
  "/Trafigura/Trafigura/Admin/Paises": "/Trafigura/Admin/Paises",
  "/Trafigura/Trafigura/Admin/Ciudades": "/Trafigura/Admin/Ciudades",
  "/Trafigura/Trafigura/Admin/Departamentos": "/Trafigura/Admin/Departamentos",
  "/Trafigura/Trafigura/Admin/Sitios": "/Trafigura/Admin/Sitios",
  "/Trafigura/Trafigura/Admin/Rutas": "/Trafigura/Admin/Rutas",
  "/Trafigura/Trafigura/Admin/Empresas": "/Trafigura/Admin/Empresas",
  "/Trafigura/Trafigura/Admin/Clientes": "/Trafigura/Admin/Clientes",
  "/Trafigura/Trafigura/Admin/TramosRutas": "/Trafigura/Admin/TramosRutas",
  "/Trafigura/Trafigura/Gestion/Programaciones": "/Trafigura/Gestion/Programaciones",
  "/Trafigura/Trafigura/Gestion/Programaciones/Reporte": "/Trafigura/Gestion/Programaciones/Reporte",
  "/Trafigura/Trafigura/Gestion/ConsultaProgramaciones": "/Trafigura/Gestion/ConsultaProgramaciones",
  "/Trafigura/Trafigura/Gestion/Viajes": "/Trafigura/Gestion/Viajes",
  "/Trafigura/Trafigura/Gestion/CentralTrafico": "/Trafigura/Gestion/CentralTrafico",
  "/Trafigura/Trafigura/Gestion/DisenoReportes": "/Trafigura/Gestion/DisenoReportes",
  "/Trafigura/Trafigura/Dashboard": "/Trafigura/Dashboard",
};

/** Rutas que tienen componente propio en trafigura/; el menú API no debe re-registrarlas. */
export const trafiguraStaticRoutePrefixes = [
  "/Trafigura/Admin/Rutas",
  "/Trafigura/Admin/RutaForm",
  "/Trafigura/Admin/TramosRutas",
  "/Trafigura/Admin/Geocercas",
  "/Trafigura/Admin/GeocercasForm",
  "/Trafigura/Admin/GeocercasPivotTable",
  "/Trafigura/Admin/Empresas",
  "/Trafigura/Admin/EmpresasForm",
  "/Trafigura/Admin/EmpresaPivotTable",
  "/Trafigura/Gestion/DisenoReportes",
  "/Trafigura/Gestion/DisenoReportes/Form",
];

export function isTrafiguraStaticRoute(path) {
  const p = String(path || "").trim();
  if (!p.startsWith("/")) return false;
  return trafiguraStaticRoutePrefixes.some(
    (prefix) =>
      p === prefix || p.startsWith(`${prefix}/`) || p.startsWith(`${prefix}:`)
  );
}

const trafiguraRoutes = [
  {
    path: "/Trafigura/Admin/Geocercas",
    name: "/Trafigura/Admin/Geocercas",
    component: () =>
      import("../views/trafigura/admin/geocercas/GeocercaIndex.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/GeocercasForm",
    name: "/Sos/Admin/Administracion/GeocercasForm",
    component: () =>
      import("../views/sos/admin/administracion/geocercas/GeocercaForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/GeocercasPivotTable",
    name: "/Sos/Admin/Administracion/GeocercasPivotTable",
    component: () =>
      import("../views/sos/admin/administracion/geocercas/GeocercaPivotTable.vue"),
  },
  {
    path: "/Trafigura/Admin/Empresas",
    name: "/Trafigura/Admin/Empresas",
    component: () =>
      import("../views/trafigura/admin/empresas/EmpresaIndex.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/EmpresasForm",
    name: "/Sos/Admin/Administracion/EmpresasForm",
    component: () =>
      import("../views/sos/admin/administracion/empresas/EmpresaForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/EmpresaPivotTable",
    name: "/Sos/Admin/Administracion/EmpresaPivotTable",
    component: () =>
      import("../views/sos/admin/administracion/empresas/EmpresaPivotTable.vue"),
  },
  {
    path: "/Trafigura/Admin/Rutas",
    name: "/Trafigura/Admin/Rutas",
    component: () =>
      import("../views/trafigura/admin/rutas/RutaIndex.vue"),
  },
  {
    path: "/Trafigura/Admin/RutaForm/:accion/:id?",
    name: "/Trafigura/Admin/RutaForm",
    component: () =>
      import("../views/trafigura/admin/rutas/RutaForm.vue"),
  },
  {
    path: "/Trafigura/Admin/TramosRutas",
    name: "/Trafigura/Admin/TramosRutas",
    component: () =>
      import("../views/trafigura/admin/tramosRutas/TrafiguraTramoRutaIndex.vue"),
  },
  {
    path: "/Trafigura/Admin/TramosRutas/:accion/:id?",
    name: "/Trafigura/Admin/TramosRutasForm",
    component: () =>
      import("../views/trafigura/admin/tramosRutas/TrafiguraTramoRutaForm.vue"),
  },
  {
    path: "/Trafigura/Flota/ConductorForm",
    name: "/Trafigura/Flota/ConductorForm",
    component: () =>
      import("../views/trafigura/flota/conductores/ConductorForm.vue"),
  },
  {
    path: "/Trafigura/Flota/VehiculoForm",
    name: "/Trafigura/Flota/VehiculoForm",
    component: () =>
      import("../views/trafigura/flota/vehiculos/VehiculoForm.vue"),
  },
  {
    path: "/Trafigura/Flota/RemolqueForm",
    name: "/Trafigura/Flota/RemolqueForm",
    component: () =>
      import("../views/trafigura/flota/remolques/RemolqueForm.vue"),
  },
  {
    path: "/Trafigura/Gestion/DisenoReportes",
    name: "/Trafigura/Gestion/DisenoReportes",
    component: () =>
      import(
        "../views/trafigura/gestion/disenoReportes/DisenoReporteIndex.vue"
      ),
  },
  {
    path: "/Trafigura/Gestion/DisenoReportes/Form/:accion/:id?",
    name: "/Trafigura/Gestion/DisenoReportes/Form",
    component: () =>
      import(
        "../views/trafigura/gestion/disenoReportes/DisenoReporteForm.vue"
      ),
  },
];

export default trafiguraRoutes;
